import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import About from '../../components/about/about';
import TestimonialSection from '../../components/TestimonialSection/TestimonialSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg'
const AboutPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} />
            <About />
            <TestimonialSection/>
            <TeamSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
